var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c(
      "div",
      {
        staticClass: "section full-width",
        class: { sectionTs: _vm.brandName === _vm.Brand.Travelsphere },
      },
      [
        _c("div", { staticClass: "container-fluid" }, [
          _c(
            "div",
            { staticClass: "filter-index", class: _vm.loading ? "pb-20" : "" },
            [
              _c("div", { staticClass: "row" }, [
                _c(
                  "div",
                  { staticClass: "col-lg-3" },
                  [
                    _c("Filters", {
                      attrs: {
                        "brand-name": _vm.brandName,
                        store: _vm.store,
                        "filter-text": _vm.filterText,
                        "filter-view-text": _vm.filterViewText,
                        "filter-close-text": _vm.filterCloseText,
                        "filter-clear-text": _vm.filterClearText,
                      },
                    }),
                    _vm._v(" "),
                    _c("Filtr", {
                      staticClass: "dropdown-filter-mobile",
                      attrs: {
                        store: _vm.store,
                        name: "SortOrder",
                        label: _vm.sortText,
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c("div", { staticClass: "col-lg-9" }, [
                  _c(
                    "div",
                    {
                      staticClass: "preferences-bar",
                      class: {
                        "preferences-barTs":
                          _vm.brandName === _vm.Brand.Travelsphere,
                      },
                    },
                    [
                      _c("p", { staticClass: "preferences-bar__title" }, [
                        _vm._v(_vm._s(_vm.itemsCount) + " - Results found"),
                      ]),
                      _vm._v(" "),
                      _c("Filtr", {
                        staticClass: "dropdown-filter-desktop",
                        attrs: {
                          store: _vm.store,
                          name: "SortOrder",
                          label: _vm.sortText,
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "filter-index__results" },
                    [
                      _vm.showNoResultsContent
                        ? _c(
                            "div",
                            { staticClass: "filter-index__no-results" },
                            [_vm._t("noResultsText")],
                            2
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "ol",
                        { staticClass: "card-list" },
                        _vm._l(_vm.items, function (item) {
                          return _c(
                            "li",
                            { key: item.id, staticClass: "card-list__item" },
                            [_vm._t("default", null, { item: item })],
                            2
                          )
                        }),
                        0
                      ),
                      _vm._v(" "),
                      _vm.loading
                        ? _c("Loading")
                        : _c("div", { staticClass: "cta-holder" }, [
                            _vm.itemsRemaining > 0
                              ? _c(
                                  "button",
                                  {
                                    staticClass: "btn btn--alt",
                                    class: {
                                      "btn-load-more":
                                        _vm.brandName ===
                                        _vm.Brand.Travelsphere,
                                    },
                                    on: { click: _vm.loadMore },
                                  },
                                  [_vm._v(_vm._s(_vm.loadMoreButtonText))]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            this.totalPages > 1
                              ? _c("div", { staticClass: "pt-20" }, [
                                  _c("strong", [_vm._v(_vm._s(this.Take))]),
                                  _vm._v(" of "),
                                  _c("strong", [
                                    _vm._v(_vm._s(this.itemsCount)),
                                  ]),
                                  _vm._v(" tours\n                "),
                                ])
                              : _vm._e(),
                          ]),
                    ],
                    1
                  ),
                ]),
              ]),
            ]
          ),
        ]),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }